"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertGranteeEntry = void 0;
var tslib_1 = require("tslib");
var UserGroupsConverter_1 = require("./UserGroupsConverter");
var UsersConverter_1 = require("./UsersConverter");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
function isGranteeUserInfo(grantee) {
    return !isEmpty_1.default(grantee) && grantee.user !== undefined;
}
exports.convertGranteeEntry = function (item) {
    if (isGranteeUserInfo(item.aclEntry.grantee)) {
        return {
            type: "user",
            user: UsersConverter_1.convertUsersItem(item.aclEntry.grantee.user),
        };
    }
    else {
        return {
            type: "group",
            userGroup: UserGroupsConverter_1.convertWorkspaceUserGroup(item.aclEntry.grantee.userGroup),
        };
    }
};
//# sourceMappingURL=GranteeEntryConverter.js.map